import React,{useState} from "react";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../assets/far-logo--2.png";

const FlagCounter = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <div style={{ minHeight: "100px", display: "flex", alignItems: "center", justifyContent: "center" }}>
      {loading && !error && (
        <span style={{ color: "#ccc", fontSize: "14px" }}>Loading visitor map...</span>
      )}
      {error && (
        <span style={{ color: "red", fontSize: "14px" }}>Failed to load visitor map.</span>
      )}
      <a href="https://info.flagcounter.com/mJNS" target="_blank" rel="noopener noreferrer">
        <img
          src="https://s01.flagcounter.com/map/mJNS/size_s/txt_000000/border_CCCCCC/pageviews_0/viewers_0/flags_0/"
          alt="Flag Counter"
          style={{
            display: loading || error ? "none" : "block",
            maxWidth: "100%",
            height: "auto",
          }}
          onLoad={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
        />
      </a>
    </div>
  );
};
const Footer = () => {
  return (
    <footer className="far-footer text-light py-10">
      <div>
        <Row className="g-8">
          <Col xs={12} lg={1}></Col>
          <Col xs={12} md={12} lg={3}>
            <div className="footer-logo">
              <img
                src={logo}
                alt="FAR Publishing Logo"
                className="img-fluid"
                style={{ maxHeight: "60px" }}
              />
            </div>

            <p
              className="text-gray-300 leading-relaxed"
              style={{
                textAlign: "justify",
              }}
            >
              FAR Publishing was founded in November 2022 and is a fully open
              access publishing house registered in Hong Kong with an
              international perspective and internet thinking. FAR is the
              abbreviation for Forth Academic Research, meaning cutting-edge
              academic research, publishing numerous journals in the fields of
              science and medicine. FAR is committed to collaborating with
              global researchers and publishing peer-reviewed high-quality
              journals to serve the global research community. Collaborate with
              global publishing houses, research institutions, and societies to
              jointly build an ecosystem for scientific publishing and improve
              open access publishing mechanisms.
            </p>
          </Col>
          <Col xs={12} md={12} lg={2}>
            <h3
              className="text-white p-0 m-0"
              style={{ height: "60px", lineHeight: "60px" }}
            >
              Contact us
            </h3>
              <div className="footer-layout-icon">

            <div>
              <svg
                t="1755769869268"
                className="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4559"
                width="24"
                height="24"
              >
                <path
                  d="M1024 512c0-282.763636-229.236364-512-512-512C229.236364 0 0 229.236364 0 512s229.236364 512 512 512C794.763636 1024 1024 794.763636 1024 512zM236.311273 693.946182c8.843636 1.117091 17.873455 1.722182 26.996364 1.722182 53.015273 0.093091 101.794909-19.037091 140.474182-51.153455-49.524364-1.163636-91.275636-36.165818-105.658182-84.200727 6.888727 1.442909 14.010182 2.280727 21.271273 2.327273 10.333091 0.046545 20.293818-1.349818 29.789091-4.049455-51.758545-11.450182-90.763636-60.555636-90.763636-119.063273 0-0.512 0-1.024 0-1.536 15.266909 9.216 32.674909 14.801455 51.246545 15.639273C279.365818 431.709091 259.397818 394.472727 259.397818 352.581818c0-22.155636 5.585455-42.821818 15.313455-60.509091 55.808 73.774545 139.170909 122.740364 233.146182 128.837818-1.954909-8.797091-2.932364-17.966545-2.932364-27.322182 0-66.141091 50.641455-118.923636 113.105455-117.899636 32.535273 0.558545 61.952 15.499636 82.571636 38.958545 25.786182-4.933818 49.989818-14.429091 71.819636-27.694545-8.424727 27.601455-26.391273 50.594909-49.757091 64.977455 22.900364-2.56 44.683636-8.610909 64.977455-17.780364-15.173818 23.598545-34.350545 44.218182-56.459636 60.695273 0.232727 5.12 0.325818 10.24 0.325818 15.36 0 157.044364-113.803636 338.152727-321.861818 338.059636C345.832727 748.311273 286.347636 728.296727 236.311273 693.946182z"
                  p-id="4560"
                  fill="#ffffff"
                ></path>
              </svg>
              <a
                href="https://twitter.com/FarGroups"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:underline"
              >
                Twitter
              </a>
            </div>
            <div>
              <svg
                t="1755769466217"
                className="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3026"
                id="mx_n_1755769466218"
                width="24"
                height="24"
              >
                <path d="M0 0 0 0 0 0Z" fill="#ffffff" p-id="3027"></path>
                <path
                  d="M512 20.48c-271.456 0-491.52 220.064-491.52 491.52s220.064 491.52 491.52 491.52 491.52-220.064 491.52-491.52-220.064-491.52-491.52-491.52zM391.68 715.712l-99.52 0 0-320.256 99.52 0 0 320.256zM341.312 356.16c-31.424 0-51.776-22.336-51.776-49.824 0-28.16 20.928-49.76 53.056-49.76s51.776 21.6 52.384 49.76c0.064 27.552-20.288 49.824-53.664 49.824zM755.136 715.712l-99.488 0 0-177.504c0-41.28-14.432-69.376-50.432-69.376-27.488 0-43.84 19.008-51.104 37.312-2.624 6.496-3.264 15.712-3.264 24.832l0 184.672-99.584 0 0-218.112c0-39.936-1.28-73.376-2.624-102.144l86.432 0 4.608 44.48 1.952 0c13.12-20.928 45.216-51.712 98.912-51.712 65.472 0 114.592 43.84 114.592 138.144l0 189.376z"
                  fill="#ffffff"
                  p-id="3028"
                ></path>
              </svg>

              <a
                href="https://www.linkedin.com/in/far-publishing-limited-126589300/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:underline"
              >
                Linkedin
              </a>
            </div>
            <div>
              <svg
                t="1755769846782"
                className="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4253"
                width="24"
                height="24"
              >
                <path
                  d="M1024 512c0-282.763636-229.236364-512-512-512C229.236364 0 0 229.236364 0 512s229.236364 512 512 512C794.763636 1024 1024 794.763636 1024 512zM374.504727 512 374.504727 414.021818l60.043636 0L434.548364 354.769455c0-79.918545 23.877818-137.495273 111.383273-137.495273l104.075636 0 0 97.745455-73.262545 0c-36.724364 0-45.056 24.389818-45.056 49.943273l0 49.058909 112.919273 0L629.201455 512l-97.512727 0 0 295.517091L434.548364 807.517091 434.548364 512 374.504727 512z"
                  p-id="4254"
                  fill="#ffffff"
                ></path>
              </svg>

              <a
                href="https://www.facebook.com/profile.php?id=61568825082155"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:underline"
              >
                Facebook
              </a>
            </div>
            <div>
              <svg
                t="1755769816935"
                className="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3446"
                width="24"
                height="24"
              >
                <path
                  d="M514.823923 570.617649a25.994804 25.994804 0 0 1-12.046372 3.170098 20.922647 20.922647 0 0 1-12.046373-3.170098L253.607844 400.700394v247.267647c0 22.190686 8.242255 22.190686 17.752549 22.190687h483.756963c8.876275 0 17.752549 0 17.752549-22.190687V402.602452z"
                  fill="#ffffff"
                  p-id="3447"
                ></path>
                <path
                  d="M866.704807 161.675001A493.267257 493.267257 0 0 0 688.545296 45.015392 499.607453 499.607453 0 0 0 507.215688 13.948431a498.973433 498.973433 0 0 0-175.623432 31.066961 490.097159 490.097159 0 0 0-178.79353 116.659609A486.927061 486.927061 0 0 0 5.072157 519.262061a486.293041 486.293041 0 0 0 147.726569 356.95304A486.927061 486.927061 0 0 0 507.215688 1023.94167a486.927061 486.927061 0 0 0 356.95304-147.726569A486.927061 486.927061 0 0 0 1014.431376 519.262061a487.56108 487.56108 0 0 0-147.726569-357.58706z m-55.159706 486.29304a57.061765 57.061765 0 0 1-59.597844 63.401961H268.190295a57.061765 57.061765 0 0 1-63.401961-63.401961V390.55608a57.061765 57.061765 0 0 1 63.401961-63.401961h483.756962a57.061765 57.061765 0 0 1 59.597844 63.401961z"
                  fill="#ffffff"
                  p-id="3448"
                ></path>
                <path
                  d="M744.973042 367.731374H277.06657l226.345 161.675 241.561472-161.675z"
                  fill="#ffffff"
                  p-id="3449"
                ></path>
              </svg>
              <a
                // href="mailto:editorial@fargroups.com"
                className="text-blue-400 hover:underline"
              >
                editorial@fargroups.com
              </a>
            </div>
            <div>
              <svg
                t="1755769834096"
                className="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3882"
                width="24"
                height="24"
              >
                <path
                  d="M420.515607 430.055541a90.234868 90.234868 0 0 0 9.599454 41.597634 101.754213 101.754213 0 0 0 17.91898 23.678653 92.794722 92.794722 0 0 0 127.992721 0 101.754213 101.754213 0 0 0 17.279017-23.678653l3.839782-8.319527a93.434686 93.434686 0 0 0 5.759672-33.278107A92.154759 92.154759 0 0 0 448.034041 364.779253a88.954941 88.954941 0 0 0-27.518434 65.276288z"
                  fill="#ffffff"
                  p-id="3883"
                ></path>
                <path
                  d="M872.969873 152.311337A490.212119 490.212119 0 0 0 512.030402 3.199818a491.492046 491.492046 0 0 0-360.299508 149.111519A491.492046 491.492046 0 0 0 0.05952 511.970882a491.492046 491.492046 0 0 0 149.111519 360.299508A492.13201 492.13201 0 0 0 512.030402 1023.941763a490.212119 490.212119 0 0 0 360.299508-149.751483A489.572156 489.572156 0 0 0 1024.001283 511.970882a489.572156 489.572156 0 0 0-151.03141-359.659545zM723.21839 511.970882a186.869372 186.869372 0 0 1-8.95949 19.838871 232.306788 232.306788 0 0 1-29.438326 42.877562l-161.270828 236.146569a21.758762 21.758762 0 0 1-17.91898 8.95949 22.398726 22.398726 0 0 1-17.918981-9.599454L332.200629 563.807933a245.746023 245.746023 0 0 1-20.478835-31.99818 226.547115 226.547115 0 0 1-23.678653-101.754212 218.227588 218.227588 0 0 1 63.99636-158.710974A216.947661 216.947661 0 0 1 512.030402 205.428316a225.267188 225.267188 0 0 1 224.627224 224.627225A236.146569 236.146569 0 0 1 723.21839 511.970882z"
                  fill="#ffffff"
                  p-id="3884"
                ></path>
              </svg>
              Room 910, 9/F, 99 Pui To Road, Tuen Mun District, New Territories, Hong Kong, China
            </div>
              </div>
          </Col>
          <Col xs={12} md={12} lg={2}>
            <h3
              className="text-white p-0 m-0"
              style={{ height: "60px", lineHeight: "60px" }}
            >
             WeChat Official Account
            </h3>
            <div>
              <img
                src="/images/wechat.png"
                alt="WeChat QR Code"
                className="max-w-full h-auto"
                style={{
                  maxHeight: "158px",
                  objectFit: "contain",
                }}
              />
              {/* <div>WeChat Official Account</div> */}
            </div>
          </Col>
          <Col xs={12} md={12} lg={2}>
            <h3
              className="text-white p-0 m-0"
              style={{ height: "60px", lineHeight: "60px" }}
            >
              Record Visitors
            </h3>
            <Row className="g-2">
              <FlagCounter />
              {/* <img src='/images/map.png' alt="map" className="max-w-full h-auto" /> */}
            </Row>
          </Col>
          <Col xs={12} lg={2}></Col>
        </Row>

        <hr className="footer-divider border-gray-700 mb-6" />

        <div className="copyright text-center text-gray-400 text-sm">
          © {new Date().getFullYear()} FAR Publishing Limited. All rights
          reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
